import * as RadixToggle from "@radix-ui/react-toggle";
import styled from "styled-components";

const Toggle = styled(RadixToggle.Root)`
  border-radius: 2rem;
  width: 4.6rem;
  height: 1.8rem;
  position: relative;
  background-color: ${({ theme }) => theme.color.grey[300]};

  ::after {
    content: "";
    position: absolute;
    left: 0;
    top: -0.2rem;
    border-radius: 50%;
    width: 2.2rem;
    height: 2.2rem;
    background-color: ${({ theme }) => theme.color.grey[400]};

    transform: translateX(0);
    transition: transform 200ms;
  }

  &[data-state="on"] {
    background-color: ${({ theme }) => theme.color.brick[300]};
    ::after {
      transform: translateX(2.4rem);
      background-color: ${({ theme }) => theme.color.brick[500]};
    }
  }

  :disabled {
    background-color: ${({ theme }) => theme.color.grey[200]};
    ::after {
      background-color: ${({ theme }) => theme.color.grey[300]};
    }
  }
`;
export default Toggle;
